import VxeGridComponent from './src/grid';
import { dynamicApp } from '../dynamics';
export var VxeGrid = Object.assign(VxeGridComponent, {
    install: function (app) {
        app.component(VxeGridComponent.name, VxeGridComponent);
    }
});
export var Grid = VxeGrid;
dynamicApp.component(VxeGridComponent.name, VxeGridComponent);
export default VxeGrid;
